import NumberOfItemsCell from './container';

export default NumberOfItemsCell;
